import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MapLibreWebGLUnavailableStyled } from "./maplibre-map-host.styled";

/**
 * Shown instead of a MapLibre canvas when the session has no WebGL2 (Testim grid, RDP, --disable-gpu).
 * The map engine cannot fall back to canvas/SVG, so the rest of the screen must keep working without it.
 */
export const MapLibreWebGLUnavailable: FC = () => {
  const { t } = useTranslation();
  const message = t("general.mapWebGL2Unavailable", {
    defaultValue:
      "Map cannot be displayed: WebGL2 is not available in this session.",
  });

  return (
    <MapLibreWebGLUnavailableStyled role="status" aria-live="polite">
      <p className="maplibre-webgl-unavailable-message">{message}</p>
    </MapLibreWebGLUnavailableStyled>
  );
};
